// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner___uvl3","load8":"Spinner_load8__Ov9qQ"};